export const EMPLOYEE_DEPENDENCY_MAP = [
  {
    group: 'identity',
    consumedBy: ['directory', 'daily-entry', 'scorecards', 'scheduler'],
  },
  {
    group: 'employment',
    consumedBy: ['scheduler', 'fleet', 'permissions', 'terminal views'],
  },
  {
    group: 'contact',
    consumedBy: ['directory', 'onboarding', 'manager follow-up'],
  },
  {
    group: 'compliance',
    consumedBy: ['onboarding', 'safety', 'hr review'],
  },
  {
    group: 'compensation',
    consumedBy: ['payroll', 'finance', 'directory compensation controls'],
  },
];
